// Fans of a school with Revamp v2 on read "drawing"; every other school keeps
// the raffle wording of the rewards pages.
export function raffleWords(user) {
  const drawing = user?.active_school?.revamp_v2 === true;
  const noun = drawing ? 'drawing' : 'raffle';
  const Noun = drawing ? 'Drawing' : 'Raffle';
  return {
    drawing,
    noun,
    nouns: `${noun}s`,
    Noun,
    Nouns: `${Noun}s`,
    weeklyPrize: drawing ? 'Bonus drop' : 'Weekly prize',
    seasonPrize: drawing ? 'Prize draw' : 'Season prize',
  };
}

// A bonus drop can sit in either slot of the leaderboard answer, so the
// prize's own draw_kind decides; the slot is the fallback for older answers.
export function isBonusDrop(prize, slot) {
  if (prize?.draw_kind) return prize.draw_kind === 'bonus_drop';
  return slot === 'weekly';
}

export const PRIZE_DRAW_HOW_TO_WIN = 'One winner is drawn from the entries at the end.';
export const BONUS_DROP_HOW_TO_WIN =
  'A smaller prize drawn from the same entry pool. Winning or losing a bonus drop does not consume your entries.';
